import { useNavigate } from 'react-router';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { HpButton } from '@hp/ui';
import { trpc } from '../../api/trpc';
import { invalidateProjects } from './queries';

export function DeleteProjectButton({ projectId, name }: { projectId: string; name: string }) {
  const { t } = useTranslation(['projects', 'common']);
  const navigate = useNavigate();
  const del = useMutation(
    trpc.projects.remove.mutationOptions({
      onSuccess: () => {
        void invalidateProjects();
        void navigate('/projects');
      },
    }),
  );

  return (
    <HpButton
      className="bo-danger"
      icon="trash"
      busy={del.isPending}
      onClick={() => {
        if (window.confirm(t('delete.confirm', { name }))) del.mutate({ id: projectId });
      }}
    >
      {del.isPending ? t('delete.deleting') : t('delete.button')}
    </HpButton>
  );
}
